
import { Vue, Component, Prop } from 'vue-property-decorator';
import DraggableFixedTable from './DraggableFixedTable.vue';
import lazyInject from '@/di';
import ShopService from '@/services/shop.service';

@Component({
  components: {
    DraggableFixedTable,
  },
})
export default class ProductSortingModal extends Vue {
  visible = false;

  @lazyInject(ShopService)
  shopService!: ShopService;

  data: any = [];

  @Prop({
    type: String,
    default: '',
  })
  shopId!: string;

  columns: any = [

    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      align: 'center',
      width: 100,
    },

    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      scopedSlots: { customRender: 'name' },
      width: 240,
      align: 'center',
    },
    {
      title: '所属分类',
      dataIndex: 'category',
      key: 'category',
      scopedSlots: { customRender: 'category' },
      align: 'center',
      width: 120,
    },

    {
      title: '市场价',
      dataIndex: 'originalPriceCent',
      key: 'originalPriceCent',
      scopedSlots: { customRender: 'originalPriceCent' },
      align: 'center',
      width: 120,
    },
    {
      title: '黑卡价',
      dataIndex: 'vipPriceCent',
      key: 'vipPriceCent',
      scopedSlots: { customRender: 'vipPriceCent' },
      align: 'center',
      width: 120,
    },

    {
      title: '创建时间',
      dataIndex: 'createTime',
      key: 'createTime',
      scopedSlots: { customRender: 'createTime' },
      align: 'center',
      width: 100,
    },

    {
      title: '状态',
      dataIndex: 'isOnline',
      key: 'isOnline',
      scopedSlots: { customRender: 'isOnline' },
      align: 'center',
      width: 120,
    },

  ];

  _data: any = [];
  updateData(val: any) {
    this._data = val;
  }

  init(val: any) {
    this.data = val;
    this.visible = true;
    const _data: any = [];
    this.data.forEach((item: any) => {
      _data.push(item.id);
    });
  }
  async submit() {
    const _data: any = [];
    this.data.forEach((item: any) => {
      _data.push(item.id);
    });
    const res = await this.shopService.shopSpuSaveRank(this.shopId, {
      ids: _data.join(','),
    });
    if (res) {
      this.visible = false;
      this.$message.success('操作成功');
      this.$emit('getShopSpus');
    }
  }

  close() {
    this.visible = false;
  }
}
